import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewsandeventsService {

  environment = environment;

  constructor(
    private _http: HttpClient,) {
      console.log(`${window.location.origin}/rssfeed/pr.json`);
    }

    pr: any = undefined;

    URL = `${window.location.origin}/rssfeed/pr.json`;
    // URL = environment.test?'https://cesar.veexinc.com/rssfeed/pr.json':'https://www.veexinc.com/rssfeed/pr.json';
    
  getprs(): Observable<any> {
    if (!this.pr) {
      this.pr = this._http.get(this.URL).pipe(
        shareReplay(1),
        catchError(error => {
          // Handle the error here, e.g., log it or return a default value
          console.error('Error fetching data:', error);
          return of({}); // Return a default value or an empty object
        })
      );
    }
    return this.pr;
  }
}
